module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35a52f87","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-ly-map/map.vue
// module id = 1207
// module chunks = 2